export const environment = {
  production: false,
  googleAnalyticsId: "",
  googleTagId: "",
  assetsUrl: "",
  url: "https://www.monabee.fr",
  api: 'https://xlel65ail2.execute-api.eu-west-3.amazonaws.com/latest',
  googleApiKey: 'AIzaSyBkhDv6P60cY0fWeVLEjlU3VfBEvLxEEw4',
};
